<script setup>
import {ref, computed, onMounted, onBeforeUnmount} from 'vue';
import {useMutation} from '@tanstack/vue-query';
import axios from 'axios';

const POSITIVE_SENTIMENT = 'Positive';

const props = defineProps({
    targetTextareaId: {
        type: String,
        default: 'reviewResponse',
    },
  websiteHasSeoAgent: {
      type: Boolean,
      required: true,
  },
});

const reviewId = ref(null);
const sentiment = ref(null);

const isPositiveReview = computed(() => sentiment.value === POSITIVE_SENTIMENT);

const handleModalOpen = (event) => {
    reviewId.value = event.detail.reviewId;
    sentiment.value = event.detail.sentiment;
    reset();
};

onMounted(() => {
    document.addEventListener('gbp-review-modal-open', handleModalOpen);
});

onBeforeUnmount(() => {
    document.removeEventListener('gbp-review-modal-open', handleModalOpen);
});

const {mutate, isPending, isError, error, reset} = useMutation({
    mutationFn: () => axios.post(`/ajax/v2/gbp/reviews/${reviewId.value}/generate-reply`),
    onSuccess: ({data}) => {
        if (data.success && data.reply) {
            const textarea = document.getElementById(props.targetTextareaId);
            if (textarea) {
                textarea.value = data.reply;
                textarea.dispatchEvent(new Event('input', {bubbles: true}));
            }
        }
    },
});
</script>

<template>
  <div>
    <button
      v-if="reviewId && isPositiveReview && websiteHasSeoAgent"
      type="button"
      class="btn btn-warning btn-sm font-weight-bold xs-mb-0"
      :disabled="isPending"
      @click="mutate()"
    >
      <span v-if="isPending">
        <i class="fas fa-spinner fa-spin xs-mr-5" /> Generating...
      </span>
      <span v-else>
        <i class="fas fa-magic xs-mr-5" /> Generate Reply
      </span>
    </button>
    <small
      v-if="isError"
      class="text-danger d-block xs-mt-5"
    >
      {{ error?.response?.data?.message ?? 'Something went wrong. Please try again.' }}
    </small>
  </div>
</template>
